export const TAC_MAX_LENGTH = 8;
export const TAC_INITIAL_RESEND_COUNT = 0;
export const TAC_STEP_INITIAL = 'TAC_STEP_INITIAL';
export const TAC_STEP_FINAL = 'TAC_STEP_FINAL';
export const TAC_STEP_RETRY = 'TAC_STEP_RETRY';

// countdown in milliseconds (2 minutes)
export const RESEND_TAC_TIMER = 120000;
export const SECURE2U_TIMER = 300000;
export const RESEND_COUNT_INCREMENT = 1;
// max num of times user can request to re-send TAC
export const MAX_RESEND_COUNT = 3;

// NOTE: used to make translation for TAC bold
export const BOLD_TAC = <b>TAC</b>;

export const TAC_TITLE_INITIAL = 'tac.beforeRequest';
export const TAC_DESCRIPTION = 'tac.description';
export const TAC_TITLE_FINAL = 'tac.timestamp';
